<template>
    <el-dialog class="event-manage" width="1200px" :visible.sync="dialogShow" :modal-append-to-body="false" append-to-body top="60px">
      <div slot="title" class="font-2x">
        <el-tabs v-model="activeTab" class="tabs-contar" @tab-click="change">
          <el-tab-pane label="设备事件" name="1"></el-tab-pane>
          <el-tab-pane label="操作记录" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="el-dialog-div">
        <div v-if="activeTab == 1">
          <rms-equip-event></rms-equip-event>
        </div>
        <div v-if="activeTab == 2">
          <event-record></event-record>
        </div>
      </div>

    </el-dialog>
</template>

<script>

export default {
  name: "EventManage",
  components: {
    RmsEquipEvent: () => import('./RmsEquipEvent.vue'),
    EventRecord: () => import('./EventRecord.vue')
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: "1",
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  created() {

  },
  methods: {
    change(e) {
      this.activeTab = e.name;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding-top: 13px;
  padding-bottom: 0px;
}
/deep/ .el-dialog__body {
  padding: 0px 20px 30px;
}
// /deep/ .el-dialog-div {
//   min-height: 725px;
// }


.operate-title {
  width: 208px;
  height: 46px;
  color: rgba(16, 16, 16, 1);
  font-size: 20px;

  .equip-event,
  .operate-record {
    height: 46px;
    line-height: 46px;
    padding-bottom: 1px;

    &.active {
      color: #07c160;
      border-bottom: 2px solid #07c160;
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.no-data {
  width: 200px;
  height: 200px;
}
</style>
<style lang="scss">
.tabs-contar>.el-tabs__header>.el-tabs__nav-wrap {
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;

    .el-tabs__item {
      font-size: 20px;
      padding: 0px 20px 20px;
    }
  }

  &::after {
    height: 1px;
  }
}
</style>